module.exports = __webpack_public_path__ + "static/media/chessGame.5ba17c47.png";